/*
  **A box that does a button's job, made reachable like one.** Added 19
  September 2026, the audit after the rebrand (issues 24 and Part 4 item 1).

  Thirteen places in OnHand were a box with a click on it: a search result you
  pick, the cards on My Counts and in Cycle Details, a notification to mark
  read, the Item Locations switch, a line's location, a sheet's rolled-up row,
  and more. A mouse or a finger worked. **A keyboard could not reach any of
  them** (Tab skipped them) and a screen reader did not say they could be
  pressed. They look identical to a button to anybody using a mouse, which is
  why they survived.

  This gives such a box what a button has, and changes nothing about how it
  looks: a place in the Tab order, the role a screen reader announces, and
  Enter or Space to press it. The app's focus ring already draws on anything
  focused.

  **A key pressed on something INSIDE the box is left alone**, because some of
  these boxes hold real buttons (a My Counts card has "Ask to reopen" on it),
  and Enter on that button must not also open the card.
*/
export function pressable(onPress, { role = 'button', ...extra } = {}) {
  if (!onPress) return {};
  return {
    role,
    tabIndex: 0,
    onClick: onPress,
    onKeyDown: e => {
      if (e.target !== e.currentTarget) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onPress(e);
      }
    },
    ...extra,
  };
}
